<template>
  <div id="eventPanel" class="EventPanelItem-styles-modal-wrapper EventPanelItem-styles-responsive-width">
    <router-link :to="{params: {event: null}, query: {c: $route.query.c,page: $route.query.page }}">
      <img src="/static/assets/img/close.svg" class="EventPanelItem-styles-close-icon">
    </router-link>
    <div class="EventPanelItem-styles-modal-content" v-if="!loading && match">
      <div data-testid="event-wrapper" class="Event-styles-score-center Event-styles-sticky">

        <section class="SoccerLive-styles-score-header" v-if="match && match.onLive && match.sport.sportId == 1">
          <div class="SoccerLive-styles-scoreboard">
            <div class="SoccerLive-styles-team">
              <div class="SoccerLive-styles-name">{{ match.competitor.oneName }}</div>
            </div>
            <div class="SoccerLive-styles-team-score">
              <span class="SoccerLive-styles-square notranslate">{{ match.data.score.home }}</span>
              <span class="SoccerLive-styles-separator">:</span>
              <span class="SoccerLive-styles-square notranslate">{{ match.data.score.away }}</span></div>
            <div class="SoccerLive-styles-team SoccerLive-styles-right">
              <div class="SoccerLive-styles-name">{{ match.competitor.twoName }}</div>
            </div>
          </div>

          <div class="SoccerLive-styles-info" v-if="match.sport.sportId == 1">
            <div class="SoccerLive-styles-team">
              <span class="SoccerLive-styles-icon SoccerLive-styles-red-card notranslate" v-if="!match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['1st half'].hasOwnProperty('red')">
                {{ parseInt(match.data.infos.stats['1st half'].red.home) }}
              </span>

              <span class="SoccerLive-styles-icon SoccerLive-styles-red-card notranslate" v-if="match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['2nd half'].hasOwnProperty('red')">
                {{ parseInt(match.data.infos.stats['1st half'].red.home) + parseInt(match.data.infos.stats['2nd half'].red.home)  }}
              </span>


              <span class="SoccerLive-styles-icon SoccerLive-styles-yellow-card notranslate" v-if="!match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['1st half'].hasOwnProperty('yellow')">
                {{ match.data.infos.stats['1st half'].yellow.home }}
              </span>

              <span class="SoccerLive-styles-icon SoccerLive-styles-yellow-card notranslate" v-if="match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['2nd half'].hasOwnProperty('yellow')">
                {{ parseInt(match.data.infos.stats['1st half'].yellow.home) + parseInt(match.data.infos.stats['2nd half'].yellow.home)  }}
              </span>

              <span class="SoccerLive-styles-icon SoccerLive-styles-corner notranslate" v-if="!match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['1st half'].hasOwnProperty('corner')">
                {{ match.data.infos.stats['1st half'].corner.home }}
              </span>

              <span class="SoccerLive-styles-icon SoccerLive-styles-corner notranslate" v-if="match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['2nd half'].hasOwnProperty('corner')">
                {{ parseInt(match.data.infos.stats['1st half'].corner.home) + parseInt(match.data.infos.stats['2nd half'].corner.home)  }}
              </span>
            </div>
            <div class="SoccerLive-styles-time">{{ periodTimer(match) }}</div>
            <div class="SoccerLive-styles-team SoccerLive-styles-right">
              <span class="SoccerLive-styles-icon SoccerLive-styles-red-card notranslate" v-if="!match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['1st half'].hasOwnProperty('red')">
                {{ parseInt(match.data.infos.stats['1st half'].red.away) }}
              </span>

              <span class="SoccerLive-styles-icon SoccerLive-styles-red-card notranslate" v-if="match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['2nd half'].hasOwnProperty('red')">
                {{ parseInt(match.data.infos.stats['1st half'].red.away) + parseInt(match.data.infos.stats['2nd half'].red.away)  }}
              </span>


              <span class="SoccerLive-styles-icon SoccerLive-styles-yellow-card notranslate" v-if="!match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['1st half'].hasOwnProperty('yellow')">
                {{ match.data.infos.stats['1st half'].yellow.away }}
              </span>

              <span class="SoccerLive-styles-icon SoccerLive-styles-yellow-card notranslate" v-if="match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['2nd half'].hasOwnProperty('yellow')">
                {{ parseInt(match.data.infos.stats['1st half'].yellow.away) + parseInt(match.data.infos.stats['2nd half'].yellow.away)  }}
              </span>



              <span class="SoccerLive-styles-icon SoccerLive-styles-corner notranslate" v-if="!match.data.infos.stats.hasOwnProperty('2nd half')">
                {{ match.data.infos.stats['1st half'].corner.away }}
              </span>

              <span class="SoccerLive-styles-icon SoccerLive-styles-corner notranslate" v-if="match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['2nd half'].hasOwnProperty('corner')">
                {{ parseInt(match.data.infos.stats['1st half'].corner.away) + parseInt(match.data.infos.stats['2nd half'].corner.away)  }}
              </span>
            </div>
          </div>
        </section>

        <section class="OtherLive-styles-scorecenter" v-if="match.onLive && match.sport.sportId > 1">
          <div class="OtherLive-styles-teams">
            <div class="OtherLive-styles-data-time">.</div>
            <div class="OtherLive-styles-team">
              <div class="OtherLive-styles-name">{{ match.competitor.oneName }}</div>
            </div>
            <div class="OtherLive-styles-team">
              <div class="OtherLive-styles-name">{{ match.competitor.twoName }}</div>
            </div>
          </div>
          <div class="OtherLive-styles-score"  v-if="match.data">
            <table class="">
              <colgroup>
                <col>
                <col class="OtherLive-styles-col-even">
                <col class="">
                <col class="OtherLive-styles-col-even">
                <col class="">
                <col class="OtherLive-styles-col-even">
                <col class="">
              </colgroup>
              <thead>
              <tr>
                <template v-for="(s,k) in match.data.infos.stats">
                  <td class="OtherLive-styles-header" v-if="k !== 'null' && k !== 'General'">{{ k.substring(0, 1) }}.</td>
                </template>

              </tr>
              </thead>
              <tbody>
              <tr>
                <template v-for="(s,k) in match.data.infos.stats">
                  <td class="OtherLive-styles-highlighted notranslate" v-if="k !== 'null' && k !== 'General'">{{ s.score.home }}</td>
                </template>
                <td class="OtherLive-styles-current notranslate"><span class="OtherLive-styles-square">{{ match.data.score.home }}</span></td>
              </tr>
              <tr>
                <template v-for="(s,k) in match.data.infos.stats">
                  <td class="OtherLive-styles-highlighted notranslate" v-if="k !== 'null' && k !== 'General'">{{ s.score.away }}</td>
                </template>
                <td class="OtherLive-styles-current notranslate"><span class="OtherLive-styles-square">{{ match.data.score.away }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section v-if="match && !match.onLive" class="OtherPreLive-styles-scorecenter">
          <div class="OtherPreLive-styles-team">
            <div class="OtherPreLive-styles-name">{{ match.competitor.oneName }}</div>
          </div>
          <section class="TimeComponent-styles-datetime">
            <div class="TimeComponent-styles-time">{{ match.startDate | moment('HH:mm', session.timezone) }}</div>
            <div class="TimeComponent-styles-date">{{ match.startDate | moment('D MMMM dddd', session.timezone) }}</div>
          </section>
          <div class="OtherPreLive-styles-team OtherPreLive-styles-right">
            <div class="OtherPreLive-styles-name">{{ match.competitor.twoName }}</div>
          </div>
        </section>
        <div>
          <div class="LiveStats-styles-live-stats-tabs-bar" v-if="match.onLive">
            <div class="LiveStats-styles-live-stats-tabs">
              <div class="LiveStats-styles-live-stats-tabs-list">
                <div class="LiveStats-styles-tab-item" v-if="match.streamEmbed"
                     :class="(page === 7) ? 'LiveStats-styles-active' : ''"
                     data-testid="tab-match" @click="changePage(7)">
                  <div class="LiveStats-styles-tab-item-icon LiveTV-styles-match"></div>
                  <div class="LiveStats-styles-tab-label">Live Stream</div>
                </div>
                <div class="LiveStats-styles-tab-item"
                     :class="(page === 9) ? 'LiveStats-styles-active' : ''"
                     data-testid="tab-match" @click="changePage(9)">
                  <div class="LiveStats-styles-tab-item-icon LiveStats-styles-match"></div>
                  <div class="LiveStats-styles-tab-label">{{ t.simulation }}</div>
                </div>
                <!--
                <div class="LiveStats-styles-tab-item"
                     :class="(page === 11) ? 'LiveStats-styles-active' : ''"
                     data-testid="tab-match" @click="changePage(11)">
                  <div class="LiveStats-styles-tab-item-icon LiveStats-styles-livestats"></div>
                  <div class="LiveStats-styles-tab-label">Canlı istatistik</div>
                </div> !-->
                <div class="LiveStats-styles-tab-item" data-testid="tab-stats"
                     :class="(page === 1) ? 'LiveStats-styles-active' : ''"
                     @click="changePage(1)">
                  <div class="LiveStats-styles-tab-item-icon LiveStats-styles-stats"></div>
                  <div class="LiveStats-styles-tab-label">{{ t.stats }}</div>
                </div>
                <div class="LiveStats-styles-tab-item" data-testid="tab-lineups">
                  <div class="LiveStats-styles-tab-item-icon LiveStats-styles-lineups"></div>
                  <div class="LiveStats-styles-tab-label">{{ t.lineups }}</div>
                </div>
                <div class="LiveStats-styles-tab-item" data-testid="tab-timeline">
                  <div class="LiveStats-styles-tab-item-icon LiveStats-styles-timeline"></div>
                  <div class="LiveStats-styles-tab-label">Timeline</div>
                </div>
              </div>
            </div>
          </div>
          <div class="ScoreCenterTabs-styles-tab-wrapper" v-if="!match.onLive">
            <div class="ScoreCenterTabs-styles-tab-list" >
              <button @click="changePage(1)" :class="(page === 1) ? 'ScoreCenterTabs-styles-selected' : ''" testid="Button_tab_button_stats" id="tab-button-stats" class="Button-styles-button TabButton-styles-tab-button ScoreCenterTabs-styles-event-tab">
              <div class="">
                <div class="ScoreCenterTabs-styles-tab-content">
                  <div class="ScoreCenterTabs-styles-tab-icon ScoreCenterTabs-styles-stats"></div>
                  <div class="ScoreCenterTabs-styles-tab-label">İstatistikler</div>
                </div>
              </div>
            </button><button testid="Button_tab_button_lineups" id="tab-button-lineups" class="Button-styles-button TabButton-styles-tab-button ScoreCenterTabs-styles-event-tab">
              <div class="">
                <div class="ScoreCenterTabs-styles-tab-content">
                  <div class="ScoreCenterTabs-styles-tab-icon ScoreCenterTabs-styles-lineups"></div>
                  <div class="ScoreCenterTabs-styles-tab-label">Kadrolar</div>
                </div>
              </div>
            </button></div>
          </div>
        </div>

        <div class="odd-pop-block sticky-container">
          <matchStats v-if="page === 1" :matchId="$route.params.event" />
          <liveStream :match="match" v-if="page === 7" />
          <liveStats :match="match" v-if="page === 11" />
          <scoreboard v-if="page === 9" layout="double" :match="match" :matchId.sync="match.rid" />
          <odd v-if="!match.isSuspended" :match="match" :matchId="$route.params.event" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import scoreboard from '@/components/sportsbook/widget/scoreboard'
  import odd from '@/components/sportsbook/odd'
  import MatchStats from "./widget/matchStats";
  import LiveStats from "./widget/liveStats";
  import liveStream from "./widget/liveStream";
  import fixture from '../../mixins/fixture';
  export default {
    name: 'matchDetail',
    components: {liveStream,LiveStats, MatchStats, odd, scoreboard},
    mixins: [fixture],
    data () {
      return {
        t: this.$root.t,
        match: '',
        session: window.session,
        page: 0,
        loading: true,
        fetchMatchInterval: null,
      }
    },
    watch: {
      '$route.params.event' (o, n) {
        this.fetchMatch()
      }
    },
    beforeDestroy() {
      clearInterval(this.fetchMatchInterval)
    },
    mounted() {
      this.fetchMatch()
      this.fetchMatchInterval = setInterval(() => {
        this.fetchMatch(0);
      }, 10000);
    },
    methods: {
      changePage (p) {

        if(this.page === p){
          this.page = 0
        }else {
          this.page = p
        }
      },
      fetchMatch(clear = true) {

        if(clear){
          this.match = null;
          this.loading = 1;
        }

        this.$http.get(bsapi + 'api/v2/fixture/e/' + this.$route.params.event, {params: {app: this.$root.app.id, locale: window.locale}}).then(response => {

              var virtualList = []
              virtualList.push(response.body.result)
              virtualList = this.compileList(virtualList)

              this.match = virtualList[4];
              this.loading = 0;

              if(this.match.onLive){

                if(this.page == 0)
                  this.page = 9;
              }

        }, response => {
          // error callback
          //this.match = null;
          this.loading = 0;

        })

        /*

        this.$http.get(bsapi + 'matches.aspx', {
          params: {match: this.$route.params.event, app: this.$root.app.id, onlyList: 1},

        }).then(response => {
          // get body data

          //this.match = response.body.result[0];
          this.loading = 0;

          if(this.match.onLive){
            this.page = 9;
          }


        }, response => {
          // error callback
          //this.match = null;
          this.loading = 0;

        })

        */
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/matchDetail.vue